<template>
<div>
     <v-system-bar :lights-out="false" @dblclick="returnDown" :window="true" class="drag-handle d-flex justify-space-between">
          <v-avatar size="29">
               <img :src="require('@/assets/admin/app/'+path)" alt="alt" />
          </v-avatar>
          <p class="subtitle-1 font-weight-black pt-4">{{ title }}</p>

          <div>
               <v-btn icon @click="minus">
                    <v-icon>mdi-minus</v-icon>
               </v-btn>
               <v-btn icon :disabled="id == 7 ? true : false" @click="returnDown">
                    <v-icon>mdi-checkbox-blank-outline</v-icon>
               </v-btn>
               <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
               </v-btn>
          </div>

     </v-system-bar>

     <v-toolbar dense class="tolbar">
          <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="  transparent" @click="refresh">
                         <v-icon>mdi-refresh</v-icon>
                    </v-btn>
               </template>
               <span>{{ $t('refresh') }}</span>
          </v-tooltip>
          <v-row class="mt-7 mx-1 d-flex">
               <v-col cols="12" sm="12">
                    <v-text-field :label="$t('search')" v-model="search" @keyup="sendSearch" append-icon="mdi-magnify" dense single-line outlined></v-text-field>
               </v-col>
          </v-row>
     </v-toolbar>

</div>
</template>

<script>
export default {

     props: {
          title: String,
          path: String,
          id: Number
     },
     data() {
          return {
               search: ''
          }
     },
     methods: {
          sendSearch() {
               Fire.$emit('search', this.search)
          },
          close() {
               this.$emit("close");
          },
          returnDown() {
               this.$emit("returnDown");
          },
          minus() {
               this.$emit("minus");
          },
          refresh() {
               if (this.id == 1) {
                    this.$store.dispatch('getDataWebsite')
                    this.$store.dispatch('getBarItems')
                    this.$store.dispatch('getStatus')
                    this.$store.dispatch('getSection')
                    this.$store.dispatch('getGaleiItem')
               } else if (this.id == 2) {
                    this.$store.dispatch('getResult')
                    this.$store.dispatch('getCartFidaliti')
               } else if (this.id == 3) {
                    this.$store.dispatch('getQuastion')
               } else if ([4, 5].includes(this.id)) {
                    this.$store.dispatch('getDemandes')
               } else if (this.id == 6) {
                    this.$store.dispatch('getMessage')
               } else if (this.id == 7) {
                    this.$store.dispatch('getSettings')
                    this.$store.dispatch('getCommune')
                    this.$store.dispatch('getWilaya')
                    this.$store.dispatch('getBarItems')
                    this.$store.dispatch('getItemBarNew')

               }

          }
     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getQuastion')
     }
}
</script>

<style scoped>
.tolbar {
     box-shadow: none !important;
}
</style>
